import { cardFlow } from "../../../mocks/portalData";

export default function CardFlow() {
  return (
    <section id="flow" className="mx-auto w-full max-w-[1320px] px-4 py-10 md:px-6 md:py-14">
      <div className="flex flex-col gap-3 md:flex-row md:items-end md:justify-between">
        <div>
          <div className="flex items-center gap-2">
            <span className="h-4 w-1 rounded-full bg-primary-500"></span>
            <h3 className="font-heading text-xl font-black text-foreground-950 md:text-2xl">热议现场 · 封面档案</h3>
          </div>
          <p className="mt-2 text-sm text-foreground-600">
            封面驱动的大型图鉴档案，每一条都是一篇可展开通读的深度梳理。
          </p>
        </div>
        <div className="flex w-fit gap-1 rounded-full border border-background-200 bg-background-100 p-1">
          {["全部", "深度长文", "行业观察", "八卦追踪"].map((label, idx) => (
            <button
              key={label}
              type="button"
              className={
                "whitespace-nowrap rounded-full px-4 py-1.5 text-sm font-bold transition-colors " +
                (idx === 0 ? "bg-primary-500 text-background-50" : "text-foreground-600 hover:text-foreground-950")
              }
            >
              {label}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-6 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {cardFlow.map((card, idx) => (
          <article
            key={idx}
            className="group flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-colors hover:border-background-300"
          >
            <a href="#flow" className="relative block h-52 w-full overflow-hidden md:h-56">
              <img
                src={card.cover}
                alt={card.title}
                title={`${card.title} 52黑料热议`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              <span className="absolute left-3 top-3 flex items-center gap-1 rounded-md bg-primary-500 px-2 py-0.5 text-xs font-bold text-background-50">
                <i className="ri-fire-fill text-xs"></i>
                {card.kind}
              </span>
              <div className="absolute inset-x-0 bottom-0 flex items-center gap-3 bg-gradient-to-t from-foreground-950/70 to-transparent px-3 pb-2.5 pt-6 text-xs text-background-50">
                <span className="flex items-center gap-1">
                  <i className="ri-eye-line"></i>
                  {card.read} 阅读
                </span>
                <span className="flex items-center gap-1">
                  <i className="ri-heart-3-line"></i>
                  {card.like}
                </span>
                <span className="ml-auto flex items-center gap-1 font-bold">
                  展开档案
                  <i className="ri-arrow-right-line text-sm"></i>
                </span>
              </div>
            </a>
            <div className="flex flex-1 flex-col gap-2 p-4">
              <h4 className="font-heading text-base font-black leading-snug text-foreground-950 transition-colors group-hover:text-primary-600">
                {card.title}
              </h4>
              <p className="text-sm leading-relaxed text-foreground-600">{card.summary}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-8 flex justify-center">
        <button
          type="button"
          className="flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300/80 px-6 py-2.5 text-sm font-bold text-foreground-800 transition-colors hover:border-background-400"
        >
          加载更多档案
          <i className="ri-refresh-line text-base"></i>
        </button>
      </div>
    </section>
  );
}